/**
 * Constantes pour les composants Planning
 * Centralise toutes les constantes utilisées dans les composants
 */

// Statuts des meetings/plannings
export const PLANNING_STATUS = {
  AVAILABLE: 10,
  PROPOSED: 20,
  WAITING: 30,
  ACCEPTED: 40,
  REFUSED: 50,
  COMPLETED: 60,
  CANCELLED: 70,
};

// Labels des statuts
export const PLANNING_STATUS_LABELS = {
  [PLANNING_STATUS.AVAILABLE]: "Disponible",
  [PLANNING_STATUS.PROPOSED]: "Convocation à envoyer",
  [PLANNING_STATUS.WAITING]: "Convocation envoyée",
  [PLANNING_STATUS.ACCEPTED]: "Accepté",
  [PLANNING_STATUS.REFUSED]: "Refusé",
  [PLANNING_STATUS.COMPLETED]: "Terminé",
  [PLANNING_STATUS.CANCELLED]: "Annulé",
};

// Classes CSS pour les statuts
export const PLANNING_STATUS_CLASSES = {
  [PLANNING_STATUS.AVAILABLE]: "meeting-available",
  [PLANNING_STATUS.PROPOSED]: "meeting-proposed",
  [PLANNING_STATUS.WAITING]: "meeting-waiting",
  [PLANNING_STATUS.ACCEPTED]: "meeting-confirmed",
  [PLANNING_STATUS.REFUSED]: "meeting-refused",
  [PLANNING_STATUS.COMPLETED]: "meeting-completed",
  [PLANNING_STATUS.CANCELLED]: "meeting-cancelled",
};

// Durées autorisées pour les sessions (en minutes)
export const ALLOWED_SESSION_DURATIONS = [30, 45, 60];

// Heures limites pour les plannings
export const TIME_CONSTRAINTS = {
  MIN_HOUR: 7,
  MIN_MINUTE: 0,
  MAX_HOUR: 19,
  MAX_MINUTE: 0,
};

// Configuration pour la recherche
export const SEARCH_CONFIG = {
  MIN_LENGTH: 3,
  DEBOUNCE_MS: 1000,
  DEBOUNCE_MS_FAST: 600,
};

// Configuration du calendrier
export const CALENDAR_CONFIG = {
  MONTHS_TO_DISPLAY: 3,
  DAY_HEADERS: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
};

// Messages d'aide et placeholders
export const UI_MESSAGES = {
  SEARCH_CANDIDACY_PLACEHOLDER:
    "Rechercher par nom ou prénom (ou laissez vide pour choisir plus tard)",
  SEARCH_CANDIDACY_PLACEHOLDER_MODIFY:
    "Modifier la candidature (ou laisser vide pour choisir plus tard)",
  SEARCH_MANAGER_PLACEHOLDER:
    "Rechercher par nom ou prénom (laisser vide pour choisir plus tard)",
  SEARCH_MANAGER_PLACEHOLDER_MODIFY:
    "Modifier le responsable (ou laisser vide pour choisir plus tard)",
  HELP_TEXT_LEAVE_EMPTY: "Laissez vide pour choisir plus tard",
  CLEAR_BUTTON_TITLE: "Effacer",
};

// Configuration API
export const API_CONFIG = {
  DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  LOCALE: "fr-FR",
};

export default {
  PLANNING_STATUS,
  PLANNING_STATUS_LABELS,
  PLANNING_STATUS_CLASSES,
  ALLOWED_SESSION_DURATIONS,
  TIME_CONSTRAINTS,
  SEARCH_CONFIG,
  CALENDAR_CONFIG,
  UI_MESSAGES,
  API_CONFIG,
};
